type DealIdeaCardProps = {
  title: string;
  description: string;
};

export const DealIdeaCard = ({ title, description }: DealIdeaCardProps) => {
  return (
    <div className="h-full rounded-[28px] lg:rounded-[40px] border-[1px] border-[#6B6B6B] px-6 py-7 lg:px-10 lg:pt-[38px] lg:pb-[42px] transition hover:bg-white/60">
      <h3 className="text-[#111] text-[19px] lg:text-[28px] leading-[1.2]">{title}</h3>
      <p className="mt-[8px] lg:mt-3 text-[#333] text-[15px] lg:text-[20px] leading-[1.4]">{description}</p>
    </div>
  );
};
